// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TypeUtils = require("../TypeUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function fromEnum(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 4;
  }
}

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* Free */0;
    case 1 :
        return /* FeeReimbursed */1;
    case 2 :
        return /* FeeNotReimbursed */2;
    case 3 :
        return /* NotProvided */3;
    default:
      return ;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "FEE_REIMBURSED") {
      return /* FeeReimbursed */1;
    } else if (param === "PARKING_INFO_NOT_PROVIDED") {
      return /* NotProvided */3;
    } else if (param === "FREE") {
      return /* Free */0;
    } else {
      return /* FeeNotReimbursed */2;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function encode(param) {
  return Relude_Globals.$great$great((function (str) {
                if (typeof str !== "number") {
                  return str._0;
                }
                switch (str) {
                  case /* Free */0 :
                      return "FREE";
                  case /* FeeReimbursed */1 :
                      return "FEE_REIMBURSED";
                  case /* FeeNotReimbursed */2 :
                      return "FEE_NOT_REIMBURSED";
                  case /* NotProvided */3 :
                      return "PARKING_INFO_NOT_PROVIDED";
                  
                }
              }), (function (prim) {
                return prim;
              }), param);
}

function toDisplayString(string) {
  if (typeof string !== "number") {
    return string._0;
  }
  switch (string) {
    case /* Free */0 :
        return "Free";
    case /* FeeReimbursed */1 :
        return "Paid - Reimbursed";
    case /* FeeNotReimbursed */2 :
        return "Paid - Not Reimbursed";
    case /* NotProvided */3 :
        return "Not Provided";
    
  }
}

function toProfessionalDescriptionString(param) {
  if (typeof param !== "number") {
    return ;
  }
  if (param === 0) {
    return ;
  }
  switch (param - 1 | 0) {
    case /* Free */0 :
        return Relude_Option.pure("You will be reimbursed for the cost of parking.");
    case /* FeeReimbursed */1 :
        return Relude_Option.pure("You will be responsible for any parking fees.");
    case /* FeeNotReimbursed */2 :
        return ;
    
  }
}

function toBusinessDescriptionString(param) {
  if (typeof param !== "number") {
    return ;
  }
  if (param === 0) {
    return ;
  }
  switch (param - 1 | 0) {
    case /* Free */0 :
        return Relude_Option.pure("Professionals pay for parking, but will be reimbursed.");
    case /* FeeReimbursed */1 :
        return Relude_Option.pure("Professionals will need to cover parking on their own.");
    case /* FeeNotReimbursed */2 :
        return ;
    
  }
}

function toSmallIcon(param) {
  if (typeof param !== "number") {
    return {
            TAG: /* Shift */6,
            _0: /* Car */5
          };
  }
  if (param === 0) {
    return {
            TAG: /* Shift */6,
            _0: /* Car */5
          };
  }
  switch (param - 1 | 0) {
    case /* Free */0 :
        return {
                TAG: /* Shift */6,
                _0: /* CarChecked */7
              };
    case /* FeeReimbursed */1 :
        return {
                TAG: /* Shift */6,
                _0: /* CarBlock */6
              };
    case /* FeeNotReimbursed */2 :
        return {
                TAG: /* Shift */6,
                _0: /* Car */5
              };
    
  }
}

var fromEnum$1 = include.fromEnum;

var toEnum$1 = include.toEnum;

var eq = include.eq;

var compare = include.compare;

var Ord = include.Ord;

var compareWithConversion = include.compareWithConversion;

var compareReversed = include.compareReversed;

var OrdReversed = include.OrdReversed;

var compareAsInt = include.compareAsInt;

var min = include.min;

var max = include.max;

var lessThan = include.lessThan;

var lt = include.lt;

var lessThanOrEq = include.lessThanOrEq;

var lte = include.lte;

var greaterThan = include.greaterThan;

var gt = include.gt;

var greaterThanOrEq = include.greaterThanOrEq;

var gte = include.gte;

var clamp = include.clamp;

var between = include.between;

var OrdRingExtensions = include.OrdRingExtensions;

var OrdNamed = include.OrdNamed;

var OrdBy = include.OrdBy;

var $$Set = include.$$Set;

var SetWithNone = include.SetWithNone;

var $$Map = include.$$Map;

var list = include.list;

var array = include.array;

var set = include.set;

var setWithNone = include.setWithNone;

var cardinality = include.cardinality;

var top = include.top;

var bottom = include.bottom;

var succ = include.succ;

var pred = include.pred;

exports.fromEnum = fromEnum$1;
exports.toEnum = toEnum$1;
exports.eq = eq;
exports.compare = compare;
exports.Ord = Ord;
exports.compareWithConversion = compareWithConversion;
exports.compareReversed = compareReversed;
exports.OrdReversed = OrdReversed;
exports.compareAsInt = compareAsInt;
exports.min = min;
exports.max = max;
exports.lessThan = lessThan;
exports.lt = lt;
exports.lessThanOrEq = lessThanOrEq;
exports.lte = lte;
exports.greaterThan = greaterThan;
exports.gt = gt;
exports.greaterThanOrEq = greaterThanOrEq;
exports.gte = gte;
exports.clamp = clamp;
exports.between = between;
exports.OrdRingExtensions = OrdRingExtensions;
exports.OrdNamed = OrdNamed;
exports.OrdBy = OrdBy;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.$$Map = $$Map;
exports.list = list;
exports.array = array;
exports.set = set;
exports.setWithNone = setWithNone;
exports.cardinality = cardinality;
exports.top = top;
exports.bottom = bottom;
exports.succ = succ;
exports.pred = pred;
exports.parseApiResponse = parseApiResponse;
exports.encode = encode;
exports.toDisplayString = toDisplayString;
exports.toProfessionalDescriptionString = toProfessionalDescriptionString;
exports.toBusinessDescriptionString = toBusinessDescriptionString;
exports.toSmallIcon = toSmallIcon;
/* include Not a pure module */
